import ImageUploadTile from './image-upload-tile'
export default ImageUploadTile
